import { KeyValueList, type KeyValueRow } from '@/components/key-value-list';
import { SecretRow } from '@/components/secret-row';
import { useCopyToClipboard } from '@/shared/hooks/use-copy-to-clipboard';
import { formatAgo } from '@/shared/lib/format';
import type { CodexConnectionData } from '@/shared/types/workspace';
import { Button } from '@/shared/ui/button';
import { useCopyCodexSecret } from '../hooks/use-copy-codex-secret';
import { maskSigningSecret } from '../model/claude-key';

type CodexDetailsProps = { connection: CodexConnectionData; canCopySecret: boolean };

export function CodexDetails({ connection, canCopySecret }: CodexDetailsProps) {
  const { copy, isCopied } = useCopyToClipboard();
  const { copySecret, isCopied: isSecretCopied, isRevealing } = useCopyCodexSecret();
  const webhookUrl = connection.webhookUrl ?? '';
  const lastEvent: KeyValueRow[] =
    connection.status === 'CONNECTED' && connection.lastEventAt
      ? [
          {
            key: 'last',
            label: 'Last event',
            value: `${connection.lastEventType ?? 'Event'}, ${formatAgo(connection.lastEventAt)}`,
          },
        ]
      : [];

  const rows: KeyValueRow[] = [
    {
      key: 'url',
      label: 'Webhook URL',
      value: (
        <SecretRow
          value={webhookUrl}
          action={
            <Button variant="ghost" size="sm" onClick={() => void copy(webhookUrl)}>
              {isCopied ? 'Copied' : 'Copy'}
            </Button>
          }
        />
      ),
    },
    {
      key: 'secret',
      label: 'Signing secret',
      value: (
        <SecretRow
          value={maskSigningSecret(connection.secretHint)}
          action={
            canCopySecret ? (
              <Button
                variant="ghost"
                size="sm"
                isLoading={isRevealing}
                onClick={() => void copySecret()}
              >
                {isSecretCopied ? 'Copied' : 'Copy secret'}
              </Button>
            ) : null
          }
        />
      ),
    },
    ...lastEvent,
  ];
  return <KeyValueList rows={rows} labelClassName="text-muted" />;
}
